// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2_BjI","colBig":"styles_colBig__l3Adm","colSmall":"styles_colSmall__3oH3e"};